import { useTranslation } from "react-i18next";

type QrSessionCardProps = {
  qrCodeDataUrl: string | null;
  isLoggedIn: boolean;
  size: number;
  onQrClick?: () => void;
};

export default function QrSessionCard({
  qrCodeDataUrl,
  isLoggedIn,
  size,
  onQrClick,
}: QrSessionCardProps) {
  const { t } = useTranslation();
  const sizeStyle = { width: size, height: size } as const;

  if (isLoggedIn) {
    return (
      <div
        className="flex flex-col items-center justify-center"
        style={sizeStyle}
      >
        <div
          className={`bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center shadow-lg shadow-emerald-200 mb-4 ${
            size > 320 ? "w-20 h-20 mb-5" : "w-16 h-16"
          }`}
        >
          <i
            className={`ri-check-line text-white ${size > 320 ? "text-4xl" : "text-3xl"}`}
          ></i>
        </div>
        <h2
          className={`font-bold text-slate-900 mb-1 ${size > 320 ? "text-xl mb-2" : "text-lg"}`}
        >
          {t("home.connection_complete")}
        </h2>
        <p className="text-sm text-slate-500">
          {t("home.redirecting_dashboard")}
        </p>
      </div>
    );
  }

  if (qrCodeDataUrl) {
    return (
      <img
        src={qrCodeDataUrl}
        alt="QR Code"
        className="cursor-pointer"
        style={sizeStyle}
        onClick={onQrClick}
      />
    );
  }

  return (
    <div className="flex items-center justify-center" style={sizeStyle}>
      <div
        className={`border-3 border-teal-500 border-t-transparent rounded-full animate-spin ${
          size > 320 ? "w-10 h-10" : "w-8 h-8"
        }`}
      ></div>
    </div>
  );
}
